module.exports = __webpack_public_path__ + "img/ten-thirty.8acc02da.png";